import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import WrappedRevenueChart from './WrappedRevenueChart';

const InsightPage = () => {
  return (
    <Box mt={3}>
      <Grid container spacing={0}>
        <Typography variant="h4">Insights</Typography>
      </Grid>
      <Grid container spacing={0}>
        <WrappedRevenueChart />
      </Grid>
    </Box>
  );
};

export default InsightPage;
